export const FreespinPromptGrid = {
  size: 100,
  gap: 1,
  name: "main",
  padding: {
    top: 5,
    bottom: 0,
    left: 5,
    right: 5,
    portrate: {
      top: 3,
      bottom: 3,
      left: 3,
      right: 3,
    },
  },
  main: [
    {
      name: "leftgrid",
      size: 70,
      type: "PortrateGridController",
      config: {
        name: "leftgrid",
        size: 100,
        gap: 0,
        main: [
          {
            name: "empty",
            size: 10,
          },
          {
            name: "freespin_prompt_holder",
            height: 50,
            size: 70,
            bounds: {
              width: 587,
              height: 482,
            },
          },
          {
            name: "empty",
            size: 10,
          },
        ],
      },
    },
  ],

  landscape: [
    {
      name: "leftgrid-land",
      size: 65,
      type: "PortrateGridController",
      config: {
        name: "leftgrid",
        size: 100,
        gap: 0,
        main: [
          {
            name: "empty",
            size: 10,
          },
          {
            name: "freespin_prompt_holder",
            height: 60,
            size: 80,
            bounds: {
              width: 587,
              height: 482,
            },
          },
          {
            name: "empty",
            size: 10,
          },
        ],
      },
    },
  ],
  portrate: [
    {
      name: "empty",
      size: 25,
    },
    {
      name: "freespin_prompt_holder",
      bounds: {
        width: 587,
        height: 482,
      },
      align: "center",
      size: 44,
    },
  ],
};
